<ng-container *ngIf="loader">
    <div class="global-loader-overlay">
        <div class="loader">
            <span class="spinner-glow spinner-glow-success mr-5"></span>
        </div>
    </div>
</ng-container>
<router-outlet></router-outlet>
